// WYVIO Motion Design System — Tokens
// Source de vérité UNIQUE pour toutes les durées et courbes de la plateforme.
// Toute animation doit passer par ces tokens. Aucune valeur ad hoc.
//
// Philosophie : Apple. Trailing douce, entrée nette, jamais de rebond cartoon.
// Toutes les durées sont exprimées en secondes (unité Framer Motion).

export const duration = {
  // Micro-interactions immédiates (hover, focus, feedback)
  fast: 0.12,
  // Standard — apparition d'un élément, changement d'onglet
  base: 0.18,
  // Transitions plus amples — drawers, révélations de sections
  slow: 0.32,
  // Grand mouvement — hero transition entre deux vues (partagée)
  hero: 0.46,
};

// Courbes cubic-bezier — nommées par intention, pas par forme.
// premium = expoOut Apple-like : démarrage vif, trailing très doux.
// standard = M3 standard, universelle.
// enter/exit = asymétrie pour éléments qui apparaissent/disparaissent.
export const easing = {
  premium: [0.22, 1, 0.36, 1],
  standard: [0.4, 0, 0.2, 1],
  enter: [0, 0, 0.2, 1],
  exit: [0.4, 0, 1, 1],
  linear: [0, 0, 1, 1],
};

// Spring physique — pour hover / press / gestures.
// stiff = plus rigide, réponse immédiate (bouton, tap).
// soft = plus fluide, mouvement de carte / hero.
// gentle = très souple, drawers / modals.
export const spring = {
  stiff: { type: "spring", stiffness: 420, damping: 34, mass: 0.9 },
  soft: { type: "spring", stiffness: 260, damping: 30, mass: 1 },
  gentle: { type: "spring", stiffness: 180, damping: 26, mass: 1 },
};

// Distance de déplacement standard pour les slides d'entrée.
// Restons discret : 8 px suffit pour donner de la vie, plus casse la fluidité.
export const distance = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 32,
};

// Stagger — délai entre children dans une liste animée.
export const stagger = {
  tight: 0.03,
  base: 0.05,
  loose: 0.08,
};
